const blobFromDataURL = async (dataURL: string): Promise<Blob> => {
  const [header, base64Data] = dataURL.split(',');
  const mimeMatch = header.match(/data:(.*?);/);

  if (!mimeMatch) {
    throw new Error('Formato Data URL inválido');
  }

  const mimeType = mimeMatch[1];
  const binary = atob(base64Data);
  const array = Uint8Array.from(binary, (c) => c.charCodeAt(0));

  return new Blob([array], { type: mimeType });
};

const blobFromBlobURL = async (blobURL: string): Promise<Blob> => {
  const response = await fetch(blobURL);
  if (!response.ok) {
    throw new Error(`Error al obtener blob: ${response.status}`);
  }
  return response.blob();
};

export const convertToBlob = async (input: string | Blob | File): Promise<Blob> => {
  if (input instanceof Blob) return input;

  if (input.startsWith('data:')) return blobFromDataURL(input);
  if (input.startsWith('blob:')) return blobFromBlobURL(input);

  throw new Error(`Formato no soportado: ${input.substring(0, 20)}...`);
};
